import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { StripeAPI } from '../api/stripe.api';

import type { Stripe } from '@stripe/stripe-js';
import type { RootState } from '../types/state.types';

/*
  Hook for loading the stripe promise to be used in the Elements components.
  Docs: https://stripe.com/docs/stripe-js/react#elements-provider
  This works because we can initially pass null as the stripePromise (once)
*/
export const useStripePromise = () => {
  const portalUrl = useSelector((state: RootState) => state.globals.portalUrl);
  const [stripeKey, setStripeKey] = useState<string>();
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null>>();

  useEffect(() => {
    import('@stripe/stripe-js').then(({ loadStripe }) => {
      StripeAPI.loadKey(portalUrl).then((key) => {
        setStripeKey(key);
      });

      if (stripeKey && !stripePromise) {
        setStripePromise(loadStripe(stripeKey));
      }
    });
  }, [stripeKey, stripePromise]);

  return stripePromise;
};
